import { render, staticRenderFns } from "./UdateApplicantOccupationInfo.vue?vue&type=template&id=32014728&scoped=true&"
import script from "./UdateApplicantOccupationInfo.vue?vue&type=script&lang=js&"
export * from "./UdateApplicantOccupationInfo.vue?vue&type=script&lang=js&"
import style0 from "./UdateApplicantOccupationInfo.vue?vue&type=style&index=0&id=32014728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32014728",
  null
  
)

export default component.exports